import { useQuery } from "@tanstack/react-query";
import { useSessionKey } from "../../app/session-sync";
import { useObjectUrl } from "../../hooks/use-object-url";
import { apiDownload } from "../../lib/api-client";

/**
 * The signed-in person's own school logo, for the menu. Only asked for when the school has one
 * (`logoUpdatedAt` from sign-in), and fetched again only when it changes.
 */
export function useOwnSchoolLogoUrl(logoUpdatedAt: string | null | undefined): string | null {
  const session = useSessionKey();
  const logo = useQuery({
    queryKey: ["institution", session, "logo", logoUpdatedAt ?? "none"],
    queryFn: ({ signal }) => apiDownload("/institution/logo", { signal }),
    enabled: Boolean(session && logoUpdatedAt),
    staleTime: Number.POSITIVE_INFINITY,
    // A missing picture just leaves the school icon in place.
    retry: false,
  });
  return useObjectUrl(logo.data);
}
